export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">关于我们</h2>
            <p className="text-foreground-600 text-sm md:text-base">了解每日吃瓜背后的故事</p>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0 w-full md:w-72">
              <div className="aspect-square rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20media%20company%20office%20with%20warm%20lighting%20and%20creative%20workspace%2C%20editorial%20newsroom%20aesthetic%2C%20large%20monitors%20displaying%20video%20content%2C%20warm%20coral%20accent%20walls%2C%20professional%20yet%20casual%20atmosphere%2C%20no%20people%20faces&width=600&height=600&seq=about-gossip-logo&orientation=squarish"
                  alt="每日吃瓜品牌介绍 - 必吃大瓜视频平台"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                每日吃瓜创立于2024年，是国内领先的娱乐八卦视频聚合平台，专注为全网瓜友提供最新、最全、最高清的明星大瓜视频和吃瓜现场实录。我们的编辑团队深耕娱乐圈多年，凭借敏锐的新闻嗅觉和广泛的人脉资源，每天为百万用户带来第一手明星爆瓜视频资讯。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台内容涵盖明星八卦、综艺爆料、恋情曝光、影视圈动态、网红圈热点等多个维度，以"必吃大瓜视频，一站式追更"为核心理念，坚持日更高质量吃瓜视频内容。我们致力于打造全网最值得信赖的吃瓜视频平台，让每一位瓜友都能在这里找到最热、最全、最新的瓜视频推荐。
              </p>
              <div className="flex flex-wrap gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line text-primary-500"></i> 服务超过200万瓜友
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-video-line text-primary-500"></i> 累计收录2000+高清瓜视频
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-team-line text-primary-500"></i> 30+ 专业编辑团队
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}